/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-undef */
import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { Switch, Route, Link } from 'react-router-dom';

import injectSheet from 'react-jss';

import HistoricalAnalysisStyles from './Historical_Analysis_Styles';

import Tournaments from './Tournaments';
import CurrentTournament from './CurrentTournament';

import Drawer from './Drawer';

const styles = HistoricalAnalysisStyles;

const HistoricalAnalysis = ({ classes }) => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  // Mobile
  const handleDrawerOpen = () => {
    setTimeout(() => {
      setIsDrawerOpen(true);
    }, 50);
  };
  const handleDrawerClose = () => {
    setIsDrawerOpen(false);
  };

  return (

    <div>

      {/* NAVBAR */}
      {window.innerWidth >= 600 && (
      <div className={classes.navbar}>
        <div className={classes.nav_title}>
          CHOOSE YOUR CHAMPION
        </div>

        <div className={classes.nav_text}>
          <div className={classes.nav_anchor}><Link to="/">Create a Bracket</Link></div>
          <div className={classes.nav_anchorselected}>Historical Analysis</div>
        </div>

        <div className={classes.qliklogo}>
          <a href="https://www.qlik.com">
            <img className={classes.qlik} src="assets/images/qlik.png" alt="Qlik" />
          </a>
        </div>
      </div>
      )}

      {/* MOBILE NAV */}
      {window.innerWidth < 600 && (
      <div className={classes.navbar}>
        <div className={classes.nav_text}>
          <div className={classes.nav_title_mob}>
            CHOOSE YOUR CHAMPION
          </div>
        </div>
        <div className={classes.hamburger} onClick={() => handleDrawerOpen()}>
          <div className={classes.hamb} />
          <div className={classes.hamb} />
          <div className={classes.hamb} />
        </div>
        <Drawer isOpen={isDrawerOpen} handleClose={() => handleDrawerClose()} />
      </div>
      )}
      <Switch>
        <Route path="/historical-analysis/" exact component={(props) => <Tournaments {...props} />} />
        <Route path="/historical-analysis/currentTournament" exact component={(props) => <CurrentTournament {...props} />} />
      </Switch>

    </div>
  );
};

HistoricalAnalysis.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default injectSheet(styles)(HistoricalAnalysis);
